// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import slide1 from "../Assets/gall1.jpg"
import slide2 from "../Assets/gall6.jpg"
import slide3 from "../Assets/gall3.jpg"
import slide4 from "../Assets/gall5.jpg"
import slide5 from "../Assets/gall4.jpg"
import slide6 from "../Assets/gall8.jpg"
import slide7 from "../Assets/gall9.jpg"
import slide8 from "../Assets/gall10.jpg"
import slide9 from "../Assets/gall2.jpg"


function Gallery() {
    const [current, setCurrent] = useState(0);

    const images = [
        slide1,
        slide2,
        slide3,
        slide4,
        slide5,
        slide6,
        slide7,
        slide8,
        slide9,

    ];


    const prevSlide = () => {
        setCurrent(current === 0 ? images.length - 1 : current - 1);
    };

    const nextSlide = () => {
        setCurrent(current === images.length - 1 ? 0 : current + 1);
    };



    return (
        <div className="min-h-screen bg-white">

            {/* Main Content Layout */}
            <main className="flex flex-col md:flex-row gap-6">


                {/* Main Section */}
                <section className="flex-1 p-4">
                    {/* Image Carousel Placeholder */}
                    <div className="relative w-full mx-auto">
                        {/* Image */}
                        <img
                            src={images[current]}
                            alt={`Slide ${current + 1}`}
                            className="w-full h-[500px] object-cover rounded shadow-md"

                        />


                        <div className="flex justify-center mt-4 gap-4">
                            <button
                                onClick={prevSlide}
                                className="bg-gray-400 text-white py-2 px-8 rounded-md hover:bg-gray-800"
                            >
                                &#10094; 
                            </button>
                            <button
                                onClick={nextSlide}
                                className="bg-gray-400 text-white py-2 px-8 rounded-md hover:bg-gray-800"
                            >
                                 &#10095;
                            </button>
                        </div>


                    </div>



                </section>
            </main>


        </div>
    );
}

export default Gallery;
